import { render, staticRenderFns } from "./Processing.vue?vue&type=template&id=1e4116e6&"
import script from "./Processing.vue?vue&type=script&lang=js&"
export * from "./Processing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4116e6')) {
      api.createRecord('1e4116e6', component.options)
    } else {
      api.reload('1e4116e6', component.options)
    }
    module.hot.accept("./Processing.vue?vue&type=template&id=1e4116e6&", function () {
      api.rerender('1e4116e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/addKnowledge/processing/Processing.vue"
export default component.exports